module.exports = { "default": require("core-js/library/fn/object/set-prototype-of"), __esModule: true };


// WEBPACK FOOTER //
// webpack:///node_modules/babel-runtime/core-js/object/set-prototype-of.js